export enum ContactType {
    AddressAr,
    AddressEn,
    Email,
    Phone,
    Fax,
    LinkedIn,
    WhatsApp,
    Facebook,
    Twitter,
    Instagram
}
